<div class="container chat-with-us-container" [ngClass]="config?.type">
  <div class="row d-none d-sm-block">
    <div class="flex-content">
      <p *ngIf="!config?.text" [innerHTML]="html"></p>
      <div *ngIf="config?.text" class="text" [innerHtml]="config?.text"></div>
      <div class="share-links">
        <a target="_blank" rel="noopener" href="https://www.facebook.com/profile.php?id=100064806753864" class="fb-bg" mat-raised-button (click)="getShareEvents('fb_chat_with_us', this.fbposition, 'facebook chat click', $event)"><i class="icon-fb"></i>{{config?.fb_text || 'CHAT WITH US'}}</a>
        <a target="_blank" rel="noopener" [href]="'https://api.whatsapp.com/send?phone=91' + variableService.contactUsMobNumber" class="whatsapp-bg"
          mat-raised-button (click)="getShareEvents('wa_chat_with_us', this.whatsposition, 'whatsapp chat click', $event)"><i class="icon-whatsapp"></i>{{config?.whats_text || 'CHAT WITH US'}}
        </a>
      </div>
    </div>
  </div>
</div>
